import { render, staticRenderFns } from "./exchange-display-settings.vue?vue&type=template&id=3e3e5642&scoped=true"
import script from "./exchange-display-settings.vue?vue&type=script&lang=js"
export * from "./exchange-display-settings.vue?vue&type=script&lang=js"
import style0 from "./exchange-display-settings.vue?vue&type=style&index=0&id=3e3e5642&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3e5642",
  null
  
)

export default component.exports